import { render, staticRenderFns } from "./agv-icon-comparison.vue?vue&type=template&id=59b3b509&scoped=true&lang=pug&"
import script from "./agv-icon-comparison.vue?vue&type=script&lang=js&"
export * from "./agv-icon-comparison.vue?vue&type=script&lang=js&"
import style0 from "./agv-icon-comparison.vue?vue&type=style&index=0&id=59b3b509&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b3b509",
  null
  
)

export default component.exports